import { render, staticRenderFns } from "./AddReferral.vue?vue&type=template&id=955b5348&"
import script from "./AddReferral.vue?vue&type=script&lang=js&"
export * from "./AddReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports